import { useState } from 'react'
import ActivityCard from '../../../../Core/Activity/ActivityCard';
import Table from './Table';
const Tab2 = ({ setSelectedCompanyAccounts, initialData, suppliername }) => {

  return (
    <div>
               <div className="px-3" style={{ background: 'white' }}>
                 
                   <div className="mb-3" >
   
                       <div className="col-md-12 px-2" style={{ display: 'flex', gap: '20px' }} >
                           <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px', border: '1px solid #DBDBDB', borderRadius: '5px' }}>
                               <div style={{ display: 'flex', gap: '15px' }}>
                                   <div style={{ flex: 1 }}>
                                       <p className='' style={{ fontSize: '16px', fontWeight: '600' }}>Default Payable Account</p>
                                   </div>
                               </div>
   
                            <Table
            setSelectedCompanyAccounts={setSelectedCompanyAccounts}
            initialData={initialData}
          />
   
   
   
   
   
                           </div>
                       </div>
   
                   </div>
                <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <ActivityCard doctype="Supplier Group" docname={suppliername} />
            </div>
          </div>
        </div>
               </div>
   
           </div >
  )
}

export default Tab2